export const APSActions = Object.freeze({
  LOG_APS_ERROR: 'LOG_APS_ERROR',
  PLAY_AD_ITEM: 'PLAY_AD_ITEM',
  REFRESH_CURRENT_ITEM: 'REFRESH_CURRENT_ITEM',
});

export const APSKeys = Object.freeze({
  SESSION_ITEMS: 'sessionItems',
});

export const APSTrackEndReasons = Object.freeze({
  ERROR: 'ERROR',
});
